export function IsSubMenu(itemMenu: ItemMenu): boolean {
    return itemMenu.menu.length > 0 && !itemMenu.forceAsNotSubmenu;
}

export interface ItemMenu {
    key: string;
    name: string;
    urlPage: string;
    isExternalUrl: boolean;
    icon: string;
    regex?: string;
    menu: ItemMenu[];
    forceAsNotSubmenu?: boolean;
    isNew: boolean;
    isAI: boolean;
    isHidden?: boolean;
    isComingSoon?: boolean;
    permissions: string[];
}
